import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';

export const SportCompetitionsListWrapper = withConfig(theme => styled('section', { label: 'SportCompetitionsListWrapper' })`
    display: flex;
    flex-flow: column nowrap;
    overflow: hidden;

    & [class$='TableSportsRowLinkWrapper'] {
        padding: ${theme.star.padding.medium};
        border: 0;
        border-bottom: 1px solid ${theme.star.unified.eventRow.borderColor};
        flex-flow: row;
        align-items: center;

        & [class$='RowLinkLabel'] {
            font-size: ${theme.star.unified.tableSportsRow.link.typography.fontSizePrimary};
            font-weight: ${theme.star.unified.tableSportsRow.link.typography.fontWeightPrimary};
            line-height: ${theme.star.unified.tableSportsRow.link.typography.lineHeightPrimary};
            display: flex;
            align-items: center;
            min-height: 44px;
        }
    }
`);
